export default __webpack_public_path__ + "static/media/f04.d32ac62f.svg";